module.exports = __webpack_public_path__ + "static/media/pdfIcon.aee9b10e.png";